<template>
  <v-app :data-name="$env.VUE_APP_NAME">
    <template v-if="user">
      <v-toolbar app color="primary" dark>
        <v-toolbar-title class="headline text-uppercase">
          <span class="font-weight-light">{{$t("Expert Panel")}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <img src="./assets/logo.png" class="toolbar-logo">
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat>{{user.fullName}}</v-btn>
          <v-btn flat @click="logout">
            <v-icon>power_settings_new</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <router-view class="authenticated-page"></router-view>
      </v-content>
    </template>
    <template v-else>
      <router-view class="blank-page"></router-view>
    </template>
  </v-app>
</template>

<script>
export default {
  name: "App",
  computed: {},
  created() {
    if (this.user && this.user.accessToken) {
      this.$api
        .refresh()
        .then(response => {
          if (!response.error) {
            if (response.list.user.typeLabel === "Expert") {
              this.$store.dispatch("refresh", { user: response.list.user });
            }
          }
        })
        .catch(error => {});
    }
  },
  data() {
    return {
      //
    };
  },
  methods: {
    logout() {
      this.$api
        .logout()
        .then(response => {
          this.$store.dispatch("logout");
        })
        .catch(error => {
          this.$store.dispatch("logout");
        });
    }
  }
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Tajawal");
html, body {
  overflow: hidden;min-height:100%; height:100%;
}
#app {
  font-family: "Tajawal", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #fff;
  overflow: hidden;
  max-height: 100%;
  .blank-page {
    background: #5379fb;
  }
  .toolbar-logo {
    display: block;
    height: 90%;
  }
}
#nprogress {
  .bar {
    background: #f8bb58 !important;
  }
  .peg {
    box-shadow: 0 0 10px #f8bb58, 0 0 5px #f8bb58 !important;
  }
  .spinner-icon {
    border-top-color: #f8bb58 !important;
    border-left-color: #f8bb58 !important;
  }
}
</style>

